import { NavLink } from 'react-router-dom'
import './admi.styles.scss'

const adminLinks = [
  { name: 'Overview', to: '/manage', end: true },
  { name: 'Inquiries', to: '/inquiry' },
  { name: 'Orders', to: '/orders' },
  { name: 'Pages', to: '/pages' },
  { name: 'Settings', to: '/settings' },
]

export const AdmiMenu = () => {
  return (
    <div className="admin-shell__menu">
      <nav className="admin-shell__nav" aria-label="Admin">
        {adminLinks.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `admin-shell__link${isActive ? ' admin-shell__link--active' : ''}`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
